import { gql } from "lib/apolloClient";
import { projectTaskSubmissionItemResponseFragment } from "Projects/routes/DeadlinesV2/modules/DeadlinesV2Fragments";

export const getProjectIBDefinedTasksQuery = gql`
  query getProjectIBDefinedTasks(
    $id: ID!
    $projectTaskFilters: ProjectTaskFilters
  ) {
    node(id: $id, type: PROJECT) {
      ... on Project {
        id
        tasks(filters: $projectTaskFilters) {
          id
          task {
            id
            title
            description
            dueOn
            closesOn
            isStudentSubmissionEnabled
            isDeadlineAllDay
            submission {
              id
              fieldUID
              type
              title
            }
          }
          isComplete
          isSubmissionTurnedIn
          latestSubmissionResponse {
            id
            isLocked

            isReturned
            isTurnedIn

            status

            submission {
              id
              fieldUID
              items {
                id
                title
                fieldUID
              }
            }

            itemResponses {
              ...projectTaskSubmissionItemResponseItem
            }
          }
        }
      }
    }
  }

  ${projectTaskSubmissionItemResponseFragment}
`;
